import { Check } from 'lucide-react';
import React from 'react';

interface PaywallFeatureProps {
    text: string;
}

const PaywallFeature: React.FC<PaywallFeatureProps> = ({ text }) => {
    return (
        <div
            className="flex justify-between items-center gap-2 w-full pr-4 pl-6 py-3 bg-osGrey-5 rounded-[18px]"
        >
            <span className="text-osBlack text-sm font-semibold">{text}</span>
            <span
                className="w-[18px] h-[18px] bg-osBlack text-white rounded-full flex items-center justify-center"
            >
                <Check strokeWidth={4} size={12} className='text-white' />
            </span>
        </div>
    );
};

export default PaywallFeature; 